import { useState, useEffect } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var checkStandalone = function checkStandalone() {
  var _navigator, _window;

  return ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.standalone) || ((_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia('(display-mode: standalone)').matches);
};

var initialState = {
  isInstallPromptSupported: false,
  promptInstall: function promptInstall() {
    return null;
  },
  isStandalone: checkStandalone()
};

var usePWA = function usePWA() {
  var _React$useState = useState(initialState),
      pwaInfos = _React$useState[0],
      setPwaInfos = _React$useState[1];

  useEffect(function () {
    var beforeinstallpromptHandler = function beforeinstallpromptHandler(e) {
      e.preventDefault();

      var promptInstall = function promptInstall() {
        try {
          return Promise.resolve(e.prompt()).then(function (promptRes) {
            if (promptRes.outcome === 'accepted') {
              setPwaInfos(_extends({}, pwaInfos, {
                isStandalone: checkStandalone()
              }));
              return true;
            }

            return false;
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };

      setPwaInfos({
        isInstallPromptSupported: true,
        promptInstall: promptInstall,
        isStandalone: checkStandalone()
      });
    };

    var onAppInstalled = function onAppInstalled() {
      setTimeout(function () {
        return setPwaInfos(_extends({}, pwaInfos, {
          isStandalone: checkStandalone()
        }));
      }, 200);
    };

    var onMatchMedia = function onMatchMedia() {
      setPwaInfos(_extends({}, pwaInfos, {
        isStandalone: checkStandalone()
      }));
    };

    window.addEventListener('beforeinstallprompt', beforeinstallpromptHandler);
    window.addEventListener('appinstalled', onAppInstalled);
    window.matchMedia('(display-mode: standalone)').addListener(onMatchMedia);
    return function () {
      window.removeEventListener('beforeinstallprompt', beforeinstallpromptHandler);
      window.removeEventListener('appinstalled', onAppInstalled);
      window.matchMedia('(display-mode: standalone)').removeEventListener("change", onMatchMedia);
    };
  }, [pwaInfos]);
  return pwaInfos;
};

export default usePWA;